import Context from "../../context/Context";
import Dataset from "./Dataset";
import FieldNames from "./FieldNames";
import * as searchUtil from "../util/searchUtil";

export default class Units extends Dataset {

  requiresFacilityMode = true;
  type = "feature";
  uidField = FieldNames.UNIT_ID;

  checkSchema() {
    const promise = new Promise((resolve,reject) => {
      if (this.layer2D) {
        let layer = this.layer2D;
        layer.when(() => {
          this.checkFieldNameProperty("uidField",layer.fields);
          resolve();
        }).catch(ex => {
          console.log("Failed to load dataset layer:",layer.title);
          console.error(ex);
          resolve();
        });
      } else {
        resolve();
      }
    });
    return promise;
  }

  getSource() {
    return Context.getInstance().aiim.datasets.categories.findSourceByKey("Units"); // TODO
  }

  queryByGeometry(geometry,meters) {
    if (!this.url) return Promise.resolve();
    const url = Context.checkMixedContent(this.url);
    const lib = Context.getInstance().lib;
    const task = new lib.esri.QueryTask({url: url});
    const query = new lib.esri.Query();
    query.outFields = ["*"];
    query.returnGeometry = true;
    query.returnZ = true;
    query.where = "1=1";
    query.geometry = geometry;
    if (typeof meters === "number" && meters > 0) {
      query.distance = meters;
      query.units = "meters";
    }
    return task.execute(query);
  }

  queryPersonUnit(peopleFeature: any, peopleDataset: any): IPromise<any> {
    if (!peopleFeature || !peopleDataset) return Promise.resolve();
    const source = this.getSource();
    const uid = peopleDataset.getUnitID(peopleFeature);
    return searchUtil.queryFieldValue(source,this.url,this.uidField,uid);
  }

}
